module.exports = __webpack_public_path__ + "img/icon-close-red.28fddc7c.svg";